export const userTypeDrop = {
    1: 'employee',
    2: 'visitor',
    3: 'contractor',
    4: 'contractor',
    5: 'supplier',
    6: 'supplier',
    7: 'resident',
};
